import { gql } from "@/services/httpAdapter";

import { RepairOrderFragment } from "./fragments";

export const onUpdateRepairOrders = gql`
	subscription onUpdateRepairOrders($commissionCycleId: String!, $payPeriodId: String!) {
		onUpdateRepairOrders(commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId) {
			locationId
			commissionCycleId
			payPeriodId
			repairOrders {
				...RepairOrder
			}
		}
	}
	${RepairOrderFragment}
`;
